import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();

let serviceTypetValidationForm = yup.object().shape({
  name: yup.string().required("Name is required"),
});
let shipViaValidationForm = yup.object().shape({
  name: yup.string().required("Name is required"),
  contact_number: yup
    .string()
    .required("Contact Number is required")
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "") return true;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch {
        return false;
      }
    }),
});
export { serviceTypetValidationForm, shipViaValidationForm };
